export default "__VITE_ASSET__DaRTnK5X__"